import React, { useEffect, useRef, useState } from 'react';

import './ImpactBand.scss';
import forest from '../../assets/forest.jpg';

const ImpactBand = () => {
  const numberRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = numberRef.current;
    if (!node || typeof IntersectionObserver === 'undefined') {
      setVisible(true);
      return;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.4 }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="impact"
      className="ImpactBand"
      style={{ backgroundImage: `url(${forest})` }}
    >
      <div className="ImpactBand__overlay" aria-hidden="true" />
      <div className="ImpactBand__inner">
        <p className="ImpactBand__eyebrow">Real environmental impact</p>
        <div
          ref={numberRef}
          className={`ImpactBand__number${visible ? ' is-visible' : ''}`}
        >
          20,166+
        </div>
        <p className="ImpactBand__caption">trees saved and counting</p>

        <h2 className="ImpactBand__heading">
          Every Wabi customer plants one tree.
        </h2>
        <p className="ImpactBand__body">
          Junk mail is a waste of your time and the planet's resources. We built
          Wabi to give you back your mailbox — and help undo the damage. Over
          100 million trees are used for junk mail every year in the US.
        </p>
      </div>
    </section>
  );
};

export default ImpactBand;
